import axios from 'axios';

export function postInvite(invitation) {
    return axios.post('/partner-invitations', invitation);
}
